import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader, StatCard } from "../../components/Shell";
import { api } from "../../lib/api";
import { ScanLine, Users, CalendarDays, FileBarChart } from "lucide-react";

export default function OrgDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/stats/org").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const tiles = [
    { to: "/org/scanner", icon: <ScanLine className="w-5 h-5" />, label: "Scan attendance", accent: true },
    { to: "/org/events", icon: <CalendarDays className="w-5 h-5" />, label: "Events" },
    { to: "/org/members", icon: <Users className="w-5 h-5" />, label: "Members" },
    { to: "/org/reports", icon: <FileBarChart className="w-5 h-5" />, label: "Reports" },
  ];

  return (
    <div data-testid="org-dashboard">
      <PageHeader eyebrow="Org Admin" title="Today" />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <StatCard label="Members" value={stats?.members ?? "—"} />
        <StatCard label="Events" value={stats?.events ?? "—"} />
        <StatCard label="Total attendance" value={stats?.attendance_total ?? "—"} />
        <StatCard label="Today" value={stats?.attendance_today ?? "—"} accent />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-0 border border-[#E4E4E7] bg-white">
        {tiles.map((t) => (
          <Link
            key={t.to}
            to={t.to}
            className={`p-6 border-r border-b md:border-b-0 border-[#E4E4E7] last:border-r-0 hover:bg-[#F7F7F8] transition-colors ${
              t.accent ? "bg-[#05126E] text-white hover:bg-[#030B45]" : ""
            }`}
            data-testid={`tile-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <div className={`w-10 h-10 grid place-items-center mb-4 border-2 ${t.accent ? "border-white" : "border-[#0a0a0a]"}`}>
              {t.icon}
            </div>
            <div className="font-bold text-lg">{t.label}</div>
            <div className={`text-xs mt-1 ${t.accent ? "text-zinc-400" : "text-zinc-500"}`}>
              Open →
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
